import { useState, useEffect } from "react";

export function useStatusDelay(status, minDuration = 400) {
  const [delayedStatus, setDelayedStatus] = useState(status);
  const [isDelaying, setIsDelaying] = useState(false);

  useEffect(() => {
    if (status === "pending") {
      setDelayedStatus("pending");
      setIsDelaying(false);
    } else if (["fulfilled", "rejected"].includes(status)) {
      setIsDelaying(true);
      const timeout = setTimeout(() => {
        setDelayedStatus(status);
        setIsDelaying(false);
      }, minDuration);

      return () => clearTimeout(timeout);
    } else {
      setDelayedStatus(status);
    }
  }, [status, minDuration]);

  return { delayedStatus, isDelaying };
}